// src/components/retreats/PainManagementRetreat.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Star, ArrowLeft } from 'lucide-react';
import Navbar from '../../common/Navbar';
import Footer from '../../common/Footer';

import heroDoctors from '../../assets/Img5.png';
import mainDoctor from '../../assets/Imgdoctor4.png';
import doc1 from '../../assets/Zwalitha1.png';
import doc2 from '../../assets/Rohith1.png';
import doc4 from '../../assets/A V Krishna Kishore1.png';
import image from '../../assets/A-card-img1.png';
import heroimage from '../../assets/doctors4.png';
import bgImage from '../../assets/banner-bg.png';
import bgCard from '../../assets/A-card-bg1.png';
import bgCard2 from '../../assets/A-Contact-bg.png';

const testimonials = [
  {
    name: 'Dr. Rakesh M.',
    date: 'Mar 2025',
    text: 'Knee OA patient’s VAS dropped from 8 to 2 in 21 days with Kati Basti + Guggulu protocol.',
  },
  {
    name: 'Dr. Shalini K.',
    date: 'Jan 2025',
    text: 'Sciatica cases walking pain-free after 14-day Matra Basti + Eranda taila series.',
  },
  {
    name: 'Dr. Praveen S.',
    date: 'Nov 2024',
    text: 'Chronic migraine reduced 80% with Nasya + Shirodhara + Pathya.',
  },
  {
    name: 'Dr. Neeta R.',
    date: 'Sep 2024',
    text: 'Frozen shoulder full ROM regained in 28 days using Upanaha + Abhyanga.',
  },
  {
    name: 'Dr. Ajit V.',
    date: 'Jul 2024',
    text: 'Now running dedicated Ayurvedic Pain OPD using these exact evidence-based protocols.',
  },
];

const PainManagementRetreat = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setActiveTestimonial((prev) => prev === 0 ? testimonials.length - 1 : prev - 1);
  };

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="bg-gray-50">
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative bg-[#EBE0CF] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 pt-20 pb-24">
          <div className="grid lg:grid-cols-2 gap-12 items-start">

            {/* LEFT CONTENT */}
            <div>
              <div className="inline-flex items-center gap-2 bg-[#0B2A2C] text-[#E5D8C2] text-xs font-bold uppercase tracking-wider px-5 py-2.5 rounded-full mb-6">
                <span className="w-2 h-2 bg-[#E5D8C2] rounded-full"></span>
                Advanced Clinical Seminar
              </div>

              <h1 className="text-2xl md:text-5xl lg:text-5xl font-extrabold text-[#0B2A2C] leading-tight mb-6">
                Evidence-Based<br />
                <span className="text-emerald-800">Ayurvedic Pain Management</span><br />
                Clinical Excellence & Protocols
              </h1>

              <p className="text-base text-[#0B2A2C] mb-8 max-w-xl leading-relaxed">
                Musculoskeletal • Neuropathic • Inflammatory • Chronic Pain<br />
                Non-opioid, holistic, outcome-oriented solutions
              </p>

              <div className="flex flex-wrap gap-4 mb-10">
                <Link
                  to="/contact"
                  className="bg-[#0B2A2C] hover:bg-[#0B2A2C] text-white font-bold px-6 py-2 rounded-full text-lg shadow-lg transition"
                >
                  Register Now
                </Link>
                <a
                  href="#curriculum"
                  className="border-2 border-[#0B2A2C] text-[#0B2A2C] hover:bg-[#E5D8C2] font-bold px-6 py-2 rounded-full text-lg transition flex items-center gap-2"
                >
                  View Sessions
                </a>
              </div>

              <div className="flex items-center gap-8">
                <div className="flex -space-x-4">
                  <div className="w-12 h-12 rounded-full bg-gray-300 border-4 border-white shadow-md"></div>
                  <div className="w-12 h-12 rounded-full bg-[#0B2A2C] border-4 border-white shadow-md flex items-center justify-center">
                    <span className="text-white font-bold text-sm">220+</span>
                  </div>
                </div>
                <p className="text-sm text-gray-600">
                  Doctors Trained<br />
                  <span className="font-medium">In Pain Management</span>
                </p>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="relative">
              <div className="">

  <img
    src={heroDoctors}
    alt="Neurology Faculty"
    className="w-full h-[650px] object-cover  -mt-24"
  />
</div>



  {/* Location Drop Icon */}
  <div className="absolute bottom-[21%] right-[33%] sm:bottom-[18%] sm:right-[25%]
    md:bottom-[7%] md:right-[40%] 
    lg:bottom-[18%] lg:right-[35%] lg:w-8 lg:h-8
    xs:bottom-[20%] xs:right-[38%]
    tb:bottom-[3%] tb:right-[40%]
    xl2:bottom-[14%] xl2:right-[37%] ab:bottom-[-3%] ab:right-[41%]
    w-5 h-5
    bg-red-500
    rounded-full
    flex items-center justify-center"
       >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-white"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
    </svg>
  </div>

  {/* Rating + Stars */}
  <div>
    <div className="absolute bottom-[21%] right-[24%] sm:bottom-[18%] sm:right-[25%]
    md:bottom-[7%] md:right-[35%]     xs:bottom-[20%] xs:right-[33%]
    tb:bottom-[4%] tb:right-[36%] ab:bottom-[-3%] ab:right-[38%]
    xl2:bottom-[17%] xl2:right-[33%]
    lg:bottom-[21%] lg:right-[30%] h-5 w-5 flex items-center gap-1">
      <span className="font-bold text-gray-900 text-lg">4.5</span>

      {/* Stars */}
      <div className="flex">
        {[...Array(4)].map((_, i) => (
          <svg
            key={i}
            className="w-4 h-4 text-amber-400 fill-amber-400"
            viewBox="0 0 20 20"
          >
            <path d="M10 15l-5.878 3.09L5.64 11.18.76 7.41l6.09-.89L10 1.5l3.15 5.02 6.09.89-4.88 3.77 1.52 6.91z" />
          </svg>
        ))}

        {/* Half Star */}
        <svg className="w-4 h-4" viewBox="0 0 20 20">
          <defs>
            <linearGradient id="half-star">
              <stop offset="50%" stopColor="rgb(251,191,36)" />
              <stop offset="50%" stopColor="#E5E7EB" />
            </linearGradient>
          </defs>
          <path
            fill="url(#half-star)"
            d="M10 15l-5.878 3.09L5.64 11.18.76 7.41l6.09-.89L10 1.5l3.15 5.02 6.09.89-4.88 3.77 1.52 6.91z"
          />
        </svg>
      </div>
    </div>

    {/* Location Name */}
    <p className="absolute bottom-[18%] right-[2%] sm:bottom-[18%] sm:right-[25%]
    md:bottom-[3%] md:right-[25%]  xs:bottom-[17%] xs:right-[18%]
    tb:bottom-[2%] tb:right-[26%] ab:bottom-[-5%] ab:right-[29%]
    xl2:bottom-[14%] xl2:right-[20%] ab:bottom
    lg:bottom-[18%] lg:right-[14%] text-xs text-gray-500 -mt-1">Vijayawada, India</p>
  </div>


            </div>
          </div>

          {/* 3-COLUMN CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mt-10">
<div className="bg-[#EBE0CF] rounded-3xl p-4 sm:p-6 shadow-xl border border-[#0B2A2C] relative overflow-hidden flex flex-col sm:flex-row">
  
  {/* TEXT CONTENT */}
  <div className="flex flex-col items-start z-10 relative w-full sm:w-2/3">
    <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#E5D8C2] rounded-full flex items-center justify-center mb-3 sm:mb-4">
      <svg
        className="w-6 h-6 sm:w-8 sm:h-8 text-[#0B2A2C]"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </div>

    <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1.5">
      Vata • Ama • Marma
      <br className="hidden sm:block" />
      Pain Physiology
    </h3>

    <p className="text-sm text-gray-600 leading-relaxed">
      Root-cause correction with Panchakarma & Rasa medicines
    </p>
  </div>

{/* IMAGE */}

  <img
    src={heroimage}
    alt="Pain Relief"
    className="absolute top-0 -right-12 h-full object-cover rounded-r-3xl" 
  />

</div>


            <div className="bg-[#E5D8C2] rounded-3xl p-6 shadow-xl border border-[#0B2A2C]">
              <h4 className="text-m font-bold text-[#0B2A2C] uppercase tracking-wider mb-4">
                4 Scientific Sessions:
              </h4>
              <ul className="text-gray-700 text-sm space-y-2 mb-5">
                <li className="flex items-center gap-2"><span className="text-[#0B2A2C]">•</span> Ayurvedic Pain Science</li>
                <li className="flex items-center gap-2"><span className="text-[#0B2A2C]">•</span> Clinical Panchakarma Protocols</li>
                <li className="flex items-center gap-2"><span className="text-[#0B2A2C]">•</span> Integrative & Comparative Approach</li>
                <li className="flex items-center gap-2"><span className="text-[#0B2A2C]">•</span> Cases & Evidence Sharing</li>
              </ul>
              <a href="#curriculum" className="text-[#0B2A2C] font-bold text-sm hover:underline">
                View full program
              </a>
            </div>

            <div className="bg-gradient-to-br from-[#EBE0CF]/70 to-[#EBE0CF]/70 rounded-3xl p-6 shadow-2xl text-black border border-[#0B2A2C]">
              <h3 className="text-lg font-bold uppercase tracking-wider mb-3">
                Ready-to-Use<br />
                Pain OPD Model
              </h3>
              <p className="text-black text-sm leading-relaxed">
                Complete protocols with VAS, WOMAC & follow-up templates
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4 SESSIONS + RIGHT DOCTOR IMAGE */}
      <section id="curriculum" className="py-14 px-6 bg-[#EBE5DB]">
  <div className="max-w-7xl mx-auto space-y-14">

    {/* MAIN CARD */}
    <div className="bg-[#EBE0CF] rounded-3xl shadow-xl border border-[#0B2A2C] overflow-hidden">
      <div className="grid lg:grid-cols-3">

        {/* LEFT */}
        <div className="lg:col-span-2 p-6 lg:p-8 mt-16">
          <div
            className="relative rounded-3xl p-6 border shadow-md"
            style={{ backgroundImage: `url(${bgCard})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div className="inline-flex items-center gap-2 bg-[#0B2A2C] text-[#E5D8C2] text-[10px] font-bold uppercase px-4 py-1.5 rounded-full mb-4">
              <span className="w-2 h-2 bg-[#E5D8C2] rounded-full"></span>
              Scientific Sessions
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0B2A2C] mb-6 leading-snug">
              Evidence-Based Ayurvedic<br />Pain Management
            </h2>

            <div className="grid grid-cols-2 gap-4">
              {[
                { title: "Pain Science", subtitle: "Vata Vyadhi • Avarana", focus: "Sandhigata • Gridhrasi • Ama" },
                { title: "Clinical Protocols", subtitle: "Basti • Kati Basti • Nasya", focus: "Guggulu • Shallaki • Rasna" },
                { title: "Integrative Approach", subtitle: "Yoga • Physiotherapy", focus: "VAS • WOMAC • Oswestry" },
                { title: "Cases & Evidence", subtitle: "Chronic & Post-trauma", focus: "Documentation • Outcomes" },
              ].map((item, i) => (
                <div
  key={i}
  className="group relative bg-[#0B2A2C] rounded-xl p-4 border shadow-md transition-all cursor-pointer"
>
  {/* Number */}
  <div className="w-10 h-10 bg-[#E5D8C2] text-[#0B2A2C] rounded-lg flex items-center justify-center mb-3 text-lg font-black group-hover:bg-[#E5D8C2] transition-all">
    0{i + 1}
  </div>

  {/* Title */}
  <h3 className="font-bold text-[#E5D8C2] text-sm leading-tight">
    {item.title}
    {item.subtitle && (
      <span className="block font-medium opacity-90 text-[11px] mt-1">
        {item.subtitle}
      </span>
    )}
  </h3>

  {/* Focus text */}
  <p className="text-[#E5D8C2]/80 text-[11px] mt-2 leading-snug">
    {item.focus}
  </p>

  {/* ARROW (restored + smaller) */}
  <div className="absolute top-3 right-3">
    <div className="w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 
                    group-hover:bg-[#E5D8C2] group-hover:shadow-md">
      <svg
        className="w-3.5 h-3.5 text-[#E5D8C2] group-hover:text-[#0B2A2C]"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <line x1="17" y1="7" x2="7" y2="17" />
        <polyline points="8 7 17 7 17 16" />
      </svg>
    </div>
  </div>
</div>

              ))}
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
<div className="relative lg:col-span-1 flex justify-center">
  <div className="w-[70%] sm:w-[60%] md:w-[50%] lg:w-full">
    <img
      src={mainDoctor}
      alt="Pain Faculty"
      className="
        w-full
        h-auto
        object-contain
        rounded-xl
        lg:rounded-tr-3xl lg:rounded-br-3xl
      "
    />
  </div>
</div>


      </div>
    </div>

    {/* BOTTOM ROW (Reduced Height) */}
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">

      <div className="md:col-span-3">
        <div className="rounded-3xl overflow-hidden shadow-xl h-[180px] md:h-[200px] border border-[#0B2A2C]">
          <img src={image} className="w-full h-full object-cover" />
        </div>
      </div>

<div className="md:col-span-6">
  <div
    className="
      relative
      rounded-3xl
      shadow-xl
      border
      flex flex-col justify-center
      p-4 sm:p-5 lg:p-6
      min-h-[180px] sm:min-h-[200px]
    "
    style={{
      backgroundImage: `url(${bgCard2})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    <h3 className="text-lg sm:text-xl lg:text-2xl font-extrabold text-[#0B2A2C] mb-2 sm:mb-3">
      Next Batch Starting Soon
    </h3>

    <p className="text-sm sm:text-base text-[#0B2A2C] mb-3 sm:mb-4">
      Limited seats • Ready-to-use pain OPD templates • Outcome tracking tools
    </p>

    <div className="flex flex-wrap gap-2">
      <Link
        to="/BookNow"
        className="
          border-2 border-[#0B2A2C]
          bg-[#0B2A2C]
          hover:bg-[#E5D8C2]
          text-white hover:text-[#0B2A2C]
          font-bold
          px-4 sm:px-5
          py-2
          rounded-full
          transition
          text-sm
        "
      >
        Reserve Seat
      </Link>

      <a
        href="#"
        className="
          border-2 border-[#0B2A2C]
          text-[#0B2A2C]
          hover:bg-[#E4D7C2]
          font-bold
          px-4
          py-2
          rounded-full
          transition
          text-sm
        "
      >
        Learn more →
      </a>
    </div>
  </div>
</div>

<div className="md:col-span-3">
  <div
    className="
      bg-[#E4D7C2]
      rounded-3xl
      shadow-xl
      border
      flex flex-col justify-between
      p-4 sm:p-5
      min-h-[180px] sm:min-h-[200px]
    "
  >
    <ul className="space-y-1.5 text-gray-700 text-xs sm:text-sm font-medium">
      <li>✔ Full pain OPD framework</li>
      <li>✔ VAS & WOMAC templates</li>
      <li>✔ Marma & Lepa charts</li>
      <li>✔ Printed material</li>
      <li>✔ Certificate included</li>
    </ul>

    <a
      href="#"
      className="mt-3 text-[#0B2A2C] font-bold hover:underline text-sm"
    >
      Learn more →
    </a>
  </div>
</div>

    </div>
  </div>
</section>


     {/* DOCTORS SECTION */}
      <section className="py-20 px-8 bg-[#E8E1D4]">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 border border-[#0B2A2C]  text-[#0B2A2C] px-6 py-2  rounded-full text-xs font-semibold mb-4">
            Expert Faculty
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B2A2C] mb-4">
            Pioneers in Cardio-Rasayana
          </h2>
          <p className="text-[#0B2A2C] mb-12 max-w-2xl mx-auto">
            Leaders in integrative cardiology, Arjuna research, hypertension, and post-MI rehabilitation
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-10">
            {[
              { name: 'Zwalitha',
                //  title: 'Cardio-Rasayana Expert', 
                 img: doc1 },
              { name: 'Rohith', 
                // title: 'Hypertension Specialist', 
                img: doc2 },
              { name: 'A V Krishna Kishore', 
                // title: 'Yoga & Heart Failure', 
                img: doc4 },
            ].map((doc, i) => (
              <div key={i} className="group cursor-pointer transition-transform duration-300 hover:-translate-y-1">
                <div className="relative rounded-3xl overflow-hidden mb-4 border-2 border-transparent group-hover:border-[#0B2A2C] group-hover:border-dotted shadow-md group-hover:shadow-xl transition-all duration-300 bg-white">
                  <img src={doc.img} alt={doc.name} className="w-full h-92 object-cover" />
                </div>
                <h4 className="text-lg font-bold text-gray-900 mt-2">{doc.name}</h4>
                <p className="text-[#0B2A2C] text-sm font-medium">{doc.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#EBE0CF] border border-[#0B2A2C] text-[#0B2A2C] px-6 py-2 rounded-full text-xs font-semibold mb-4">
              Doctor Testimonials
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0B2A2C] mb-6">
              Real Clinical Results<br />
              from Trained Physicians
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Hear from doctors who now confidently manage complex cardiac cases with Ayurvedic protocols
            </p>
          </div>

          <div className="relative">
            <div className="bg-[#EBE0CF] rounded-3xl p-8 md:p-10 shadow-lg border border-gray-200 min-h-[260px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <p className="font-semibold text-[#0B2A2C]">
                      {testimonials[activeTestimonial].name}
                    </p>
                    <p className="text-xs text-[#0B2A2C]">
                      {testimonials[activeTestimonial].date}
                    </p>
                  </div>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                </div>
                <p className="text-[#0B2A2C] text-base leading-relaxed">
                  {testimonials[activeTestimonial].text}
                </p>
              </div>

              <div className="mt-6 flex items-center justify-between">
                <div className="flex gap-2">
                  {testimonials.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setActiveTestimonial(idx)}
                      className={`h-2 rounded-full transition-all ${
                        idx === activeTestimonial
                          ? 'w-8 bg-[#0B2A2C]'
                          : 'w-2 bg-gray-400'
                      }`}
                    />
                  ))}
                </div>
                <div className="flex gap-3">
                  <button onClick={handlePrev} className="w-9 h-9 rounded-full border border-[#0B2A2C] flex items-center justify-center hover:bg-gray-200">
                    <ArrowLeft className="w-4 h-4" />
                  </button>
                  <button onClick={handleNext} className="w-9 h-9 rounded-full border border-[#0B2A2C] flex items-center justify-center hover:bg-gray-200 rotate-180">
                    <ArrowLeft className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section
        className="py-24 text-white text-center bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-[#EBE0CF]">
            Next Batch Starts Soon<br />
            Only 20 Seats Available
          </h2>
          <p className="text-lg md:text-2xl mb-10">
            Master evidence-based Ayurvedic cardiology with live cases & research faculty
          </p>
          <Link
            to="/BookNow"
            className="bg-white text-emerald-700 hover:bg-gray-100 px-12 md:px-20 py-4 md:py-5 rounded-full text-lg md:text-2xl font-black inline-flex items-center gap-4 shadow-2xl"
          >
            <Calendar className="w-6 h-6 md:w-8 md:h-8" />
            Reserve Your Seat Now
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PainManagementRetreat;